function percentageToFloat(str) {
  // Check if string ends with '%'
  if (str && typeof str === "string" && str.endsWith("%")) {
    // Remove '%' symbol and convert to float
    const floatVal = parseFloat(str.slice(0, -1)) / 100;
    return floatVal;
  } else if (str) {
    return parseFloat(str) / 100;
  } else return str;
  // Return original string if it's not a percentage value
}

const matchContent = (glossary, field) => {
  if (glossary.length !== 0) {
    return JSON.parse(
      glossary.find((obj) => obj.pole.toLowerCase() === field.toLowerCase())
        .zawartosc
    );
  } else return [];
};

const percentage = (arr) => {
  return arr ? arr.map((elem) => +(elem * 100).toFixed(2) + "%") : [];
};

const validateInput = (elem) => {
  if(elem){
    if (elem.innerText && elem.innerText != parseFloat(elem.innerText)) {
      elem.style.background = "pink";
    }
    else {
      if(elem.id.split('-')[elem.id.split('-').length-1] % 5 == 4 ) { //every 5th element
        elem.style.background = "darkgrey";
      } else {
        elem.style.background = "none";
      }
    }
  }
};

const validateInputForPercent = (elem) => {
  if (elem.innerText && elem.innerText.replace(' %', '') != parseFloat(elem.innerText.replace(' %', ''))) {
    elem.style.background = "pink";
  } else {
    elem.style.background = "none";
  }
};

const formatPercentage = (event) => {
  const div = event.target;
  const input = div.textContent.replace(/[^0-9.]/g, ""); // remain only numbers and "."
  const number = parseFloat(input); // Parse the input as a number

  // Check if the input is a valid number
  if (!isNaN(number)) {
    const formattedNumber = number % 1 !== 0 ? number.toFixed(2) : number; // Check if there is a decimal part
    div.textContent = formattedNumber + "%"; // Format the number with 2 decimal places and append the percentage sign
  } else {
    div.textContent = null; // Clear the content if the input is not a valid number
  }
};

function roundUpToNearestRange(number) {
  if (number >= 100 && number <= 999) {
    return Math.ceil(number / 100) * 100;
  } else if (number >= 1000 && number <= 9999) {
    return Math.ceil(number / 1000) * 1000;
  } else if (number >= 10000 && number <= 99999) {
    return Math.ceil(number / 10000) * 10000;
  } else if (number >= 100000 && number <= 999999) {
    return Math.ceil(number / 100000) * 100000;
  } else {
    return number; // Return the original number if it doesn't fall into any range
  }
}

const parse = (data) => {
  data = data || null;
  let parsedData = null;
  try {
    parsedData = JSON.parse(data);
  } catch (error) {
    // Handle the error here, such as logging or displaying an error message
    // console.error("Error parsing JSON:", error);
  }
  if (parsedData) {
    return parsedData;
  } else return null;
};

const parseNumber = (something) => {
  if (something == parseFloat(something)) return parseFloat(something);
  else return NaN;
};

export {
  percentageToFloat,
  matchContent,
  percentage,
  validateInput,
    validateInputForPercent,
  formatPercentage,
  roundUpToNearestRange,
  parse,
  parseNumber,
};
